import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {
    Box,
    Heading,
    Flex,
} from '@chakra-ui/react';
import { PrismicRichText } from "@prismicio/react"
import CtaButton from '../CtaButton/CtaButton';


export default function FullImageSection({ slice }) {
    return (
        <Box>
            <Box h="4" bg={slice.primary.button_color === "Blue" ? ("blue.400") : ("vintage-yellow.500")} />
            <Box h="4" bg={slice.primary.button_color === "Blue" ? ("blue.500") : ("poppy.500")} />
                <Box position="relative" className='full-width-image-slice'>
                    <GatsbyImage image={(getImage(slice.primary.image.localFile))} alt={slice.primary.image.alt} imgStyle={{width: '100%'}}/>
                    {/* Medium Screens */}
                    <Flex position="absolute" top="0" left="0" w="100%" h="100%" justifyContent="flex-end" display={{base: 'none', md: 'flex'}}>
                        <Flex flexDirection="column" h="100%" w="50%" justifyContent="center" pr="36">
                            <Box>
                                <Heading as="h3" variant="h3" textAlign="left" color="white" fontSize={["4xl", "4xl", "4xl", "4xl", "6xl"]} textShadow="0px 0px 5px rgba(0,0,0,0.5);">
                                    {slice.primary.headline.text}
                                </Heading>
                            </Box>
                            <Box color="white" textShadow="0px 0px 5px rgba(0,0,0,0.5);" fontSize={{base: "1.125rem", md: "1.5rem", lg: "2rem"}} fontWeight="500" >
                                <PrismicRichText field={slice.primary.text_content.richText} />
                            </Box>
                            <Box mt="8">
                                <CtaButton 
                                    variant={slice.primary.button_color === "Blue" ? ('Blue') : slice.primary.button_color === "Yellow" ? ('Yellow') : slice.primary.button_color === "Orange" ? ('Orange') : ('Green') }
                                    size={["md", "lg"]}
                                    linkTo={slice.primary.button_link.url}
                                    buttonLabel={slice.primary.button_label}
                                />
                            </Box>
                        </Flex>
                    </Flex>
                    {/* Small Screens */}
                    <Flex position="absolute" top="0" left="0" w="100%" h="100%" justifyContent="center" display={{base: 'flex', md: 'none'}}>
                        <Flex flexDirection="column" h="100%" w="100%" justifyContent="center" px="4">
                            <Box>
                                <Heading as="h1" variant="h1" textAlign="center" color="white" fontSize="2xl" textShadow="0px 0px 5px rgba(0,0,0,0.5);">
                                    {slice.primary.headline.text}
                                </Heading>
                            </Box>
                            <Box color="white" fontSize="1rem" fontWeight="500" textAlign="center" textShadow="0px 0px 5px rgba(0,0,0,0.5);" className='mobile-fullscreen-slice-richtext'>
                                <PrismicRichText field={slice.primary.text_content.richText} />
                            </Box>
                            <Box mt="2" textAlign="center">
                                <CtaButton 
                                    variant={slice.primary.button_color === "Blue" ? ('Blue') : slice.primary.button_color === "Yellow" ? ('Yellow') : slice.primary.button_color === "Orange" ? ('Orange') : ('Green') }
                                    size="sm"
                                    linkTo={slice.primary.button_link.url}
                                    buttonLabel={slice.primary.button_label}
                                />
                            </Box>
                        </Flex>
                    </Flex>

                </Box>
                
            <Box h="4" bg={slice.primary.button_color === "Blue" ? ("blue.500") : ("poppy.500")} />    
            <Box h="4" bg={slice.primary.button_color === "Blue" ? ("blue.400") : ("vintage-yellow.500")} />
            
        </Box>
    )
}
